import type { ITextReplaceRule, RuleApplyOnType } from '@carboncopyco/types';
import { isEqual } from 'lodash-es';

export function updateApplyRuleOnUrlList(
  selectedOption: RuleApplyOnType,
  decodedUrl: string
): string[] {
  return selectedOption === 'allPages' ? ['*'] : [decodedUrl];
}

export function isRuleApplyToAllPages(urlList: string[]): boolean {
  if (urlList) {
    return urlList.length === 1 && urlList[0] === '*';
  }
  return true;
}

export const hasSimilarRule = (
  rules: ITextReplaceRule[],
  currentRule: Partial<ITextReplaceRule>
): boolean => {
  const result = rules.find((rule) => {
    if (rule.ruleId !== currentRule.ruleId) {
      const hasSameOptions = isEqual(currentRule.options, rule.options);
      if (hasSameOptions) {
        return (
          currentRule?.oldValue.toLowerCase().trim() ===
          rule.oldValue.toLowerCase().trim()
        );
      }
    }
  });

  return !!result;
};

export const isTextOldValueIsDuplicate = (
  rules: ITextReplaceRule[],
  oldValue: string
): boolean => {
  return rules.some(
    (rule) =>
      rule?.oldValue &&
      rule.oldValue.toLowerCase().trim() === oldValue.toLowerCase().trim()
  );
};
